module.exports = __webpack_public_path__ + "media/images/app/checkout/cards-checkout-c6fdc073ae0ba572b93a4ed076be371f.webp";